// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25YUx","index":"styles_index__8fij9"};